var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.details)?_c('div',_vm._l((_vm.details.details),function(detail,name){return _c('ul',[_c('li',[_vm._v(_vm._s(name)+": "+_vm._s(detail))])])}),0):_vm._e(),(_vm.error)?_c('p',[_vm._v(_vm._s(_vm.errorMsg))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }